export default __webpack_public_path__ + "static/media/rebate.c17f446a.mp3";